import gql from 'graphql-tag'

export const productsDocument = gql`
  query Skus($pagination: PaginationInput, $onSale: Boolean, $track: String) {
  skus(pagination: $pagination, on_sale: $onSale, track: $track) {
    nodes {
      commodity_id
      name
      id
      cover_uri
      price
      spec_attrs {
        key
        value
      }
      platforms
    }
    page_info {
      has_next_page
      end_cursor
    }
    total_count
  }
}
`
